module.exports = __webpack_public_path__ + "static/media/thumb-down-svgrepo-com (3).18238abf.svg";